export class StorageConstant {
  static USER = 'user';
  static FIRST_NAME = 'first-name';
  static IS_USER_SIGNED_OUT = 'is-user-signed-out';
  static GROUP = 'group';
  static EVENT = 'event';
}
